export const msalConfig = {
  auth: {
    clientId: "cb6ffe31-b85f-4651-b646-ed30d49c650d",
    authority: `https://login.microsoftonline.com/1e256d73-e813-4b50-91ec-4bd804bdc7f1`,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"]
};
